import { useRef, useState } from "react";
import { ExternalLink, MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { BLOG_CMS_COPY } from "@/lib/blog-cms/copy";
import { AgentLinkDialog } from "./AgentLinkDialog";

/**
 * The `/blog-cms` header controls (T14). 40 px icon buttons with accessible names below 1440 px;
 * "Open in new tab" moves into the overflow menu below 640 px. Every control is `outline` (M1-9).
 */
export function BlogCmsHeaderActions({ onOpenInNewTab }: { onOpenInNewTab: () => void }) {
  const [agentOpen, setAgentOpen] = useState(false);
  const menuTriggerRef = useRef<HTMLButtonElement | null>(null);

  return (
    <>
      <Button
        variant="outline"
        size="icon"
        aria-label={BLOG_CMS_COPY.openInNewTab}
        title={BLOG_CMS_COPY.openInNewTab}
        className="hidden sm:inline-flex min-[1440px]:w-auto min-[1440px]:px-3"
        onClick={onOpenInNewTab}
      >
        <ExternalLink className="h-4 w-4" aria-hidden="true" />
        <span className="hidden min-[1440px]:ml-2 min-[1440px]:inline">
          {BLOG_CMS_COPY.openInNewTab}
        </span>
      </Button>
      {/* modal={false}: the menu-to-dialog hand-off would otherwise leave pointer-events:none on <body>. */}
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button
            ref={menuTriggerRef}
            variant="outline"
            size="icon"
            aria-label={BLOG_CMS_COPY.editorActions}
            title={BLOG_CMS_COPY.editorActions}
          >
            <MoreHorizontal className="h-4 w-4" aria-hidden="true" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem className="sm:hidden" onSelect={onOpenInNewTab}>
            {BLOG_CMS_COPY.openInNewTab}
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setAgentOpen(true)}>
            {BLOG_CMS_COPY.agentTitle}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <AgentLinkDialog
        open={agentOpen}
        onOpenChange={setAgentOpen}
        returnFocusRef={menuTriggerRef}
      />
    </>
  );
}
